import { createRequest, RequestConfig } from 'app/common/api';

import { TRole } from '../core/role';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_role',
};

export const updateRoleRequest = (body: TRole) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
